<template>
    <footer class="container">
        <div class="flex">
            <small>Tous droits réservés Sabrina Pezzin <a href="">Conditions générales & vie privée</a></small>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>